module.exports = __webpack_public_path__ + "img/first-last-authors-rc.45e3dcf9.jpg";